import { Button, Link, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import { CaymanCountryLogoWithText } from '@/components/Icon/Logo';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { getDataTestId } from '@/utils/browser';

export default function CaymanThirdPartyComplianceCheckFailedPage() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: (
          <CaymanCountryLogoWithText alt="Cayman Country Logo with Text" />
        ),
      }}
    >
      <Typography
        variant="h4"
        mt={20}
        {...getDataTestId('cayman-validation-personal-failed-page-title')}
      >
        {t('createNewAccount.caymanPersonalValidationFailed.header')}
      </Typography>
      <Typography
        variant="body2"
        mt={4}
        {...getDataTestId('cayman-validation-personal-failed-page-body')}
      >
        <Trans
          i18nKey="createNewAccount.caymanPersonalValidationFailed.body"
          components={{
            PhoneLink: (
              <Link color="primary" fontWeight="bold" href="tel:345-949-8300" />
            ),
          }}
        />
      </Typography>
      <Form>
        <Button
          onClick={onBackToSignIn}
          {...getDataTestId(
            'cayman-validation-personal-failed-page-login-button',
          )}
        >
          {t(
            'createNewAccount.caymanPersonalValidationFailed.button.backToLogin',
          )}
        </Button>
      </Form>
    </Page>
  );
}
